import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component(async (node) => {
  const sizeCloseBtn = node.querySelector<HTMLElement>('[data-close-btn]');

  const initSizeDrawer = () => {
    const sizeDrawer = Drawer(node);

    sizeDrawer.on('open', () => {
      document.documentElement.style.overflow = 'hidden';
    });

    sizeDrawer.on('close', () => {
      document.documentElement.style.overflow = '';
    });

    document.addEventListener('sizeDrawer:open', () => {
      sizeDrawer.open();
    });

    sizeCloseBtn.addEventListener('click', () => {
      sizeDrawer.close();
    });
  };

  const init = () => {
    initSizeDrawer();
  };

  init();
});
